import { z } from 'zod';

export namespace WorkspacesAPI {
  export const transcribeFileRequestParamsSchema = z.object({
    fileId: z.coerce.number(),
    workspaceId: z.coerce.number(),
  });

  export type TranscribeFileRequest = z.infer<typeof transcribeFileRequestParamsSchema>;

  export const preFileUploadCheckRequestBodySchema = z.object({
    files: z.array(
      z.object({
        identifier: z.string(),
        name: z.string(),
        lastModified: z.number().optional(),
        size: z.number().optional(),
        type: z.string().optional(),
      }),
    ),
    parentObjectId: z.number(),
  });

  export const preFileUploadCheckRequestParamsSchema = z.object({
    workspaceId: z.coerce.number(),
  });

  export type PreFileUploadCheckRequest = z.infer<typeof preFileUploadCheckRequestBodySchema> & z.infer<typeof preFileUploadCheckRequestParamsSchema>;

  export const preFileUploadCheckResponseBodySchema = z.object({
    existing: z.array(z.string()),
    transcribable: z.array(z.string()),
  });

  export type PreFileUploadCheckResponse = z.infer<typeof preFileUploadCheckResponseBodySchema>;
};